import React from "react";
import VoicePricingBanner from "../PageBanners/VoicePricingBanner";
import VoicePricing from "../Common/VoicePricing";
import Footer from "../Common/Footer";

class VoicePricingPage extends React.Component {
  render() {
    return (
      <>
        <VoicePricingBanner />
        <VoicePricing />
        <Footer />
      </>
    );
  }
}

export default VoicePricingPage;
